import { gql } from "@apollo/client";

export const GET_GESTION_LOGISTICA_CLIENTE = gql`
query GetClienteByCodigo (
    $codigo: String!
){
    clienteByCodigo(codigo: $codigo ) {
        success,
        error,
        valorEsperado {
            cod_Cliente,
            nom_Com
        }
    }
}
`;